import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import ColumnChart from "../../charts/ColumnChart";
import BlockChart from "../../BlockChart";
import {useFormattedLanguage} from "../../utils";

const ConsentByRankChart = ( {data = [], isSuccess, isFetching: isLoading, refetch} ) => {
  const { t } = useTranslation();
  const formatData = (data) => (
    {
      categories: data.map((elt) => (t(elt.display_rank))),
      series: [
        {
          name: 'consent',
          data: data.map((elt) => ( elt.count ? 100 * elt.accepted_count / elt.count : 0 ) )
        }
      ]
    }
  )
  const formattedData = useMemo(() => (formatData(data)), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentsByRank")} isLoading={isLoading} isSuccess={isSuccess}>
      <ColumnChart data={formattedData} legendOptions={{show: false}}/>
    </BlockChart>
  )
}

export default ConsentByRankChart
